import { initSentry } from '@mopla/logger';

import { environment } from '../environments/environment';

export const initPassengerSentry = () =>
	initSentry({
		dsn: environment.sentryDns,
		environment: environment.env,
		tracePropagationTargets: [environment.baseUrl],
		appName: 'passenger',
	});
